<template>
  <v-layout column>
    <v-layout align-center>
      <h2
        v-if="compactMode"
        class="subheading font-weight-bold pr-1"
      >
        Звенья
      </h2>
      <v-btn
        v-if="!compactMode"
        small
        flat
        :color="isPhaseActive ? 'primary' : ''"
        @click="changePhaseActive"
      >
        Звенья
      </v-btn>
      <v-btn
        v-if="!compactMode"
        small
        flat
        :color="isReleaseOrderActive ? 'primary' : ''"
        @click="changeReleaseOrderActive"
      >
        Отгрузки
      </v-btn>
      <v-divider
        vertical
        class="mx-2"
      />
      <template>
        <div class="text-xs-center">
          <v-btn
            v-if="!user.hasEmployee"
            slot="activator"
            color="primary"
            small
            @click="showInfo('Пользователь не привязан к сотруднику')"
          >
            Добавить
          </v-btn>
          <v-menu
            v-else
            v-model="phasesPoint"
            offset-y
            top
            :disabled="readonly || !canEdit || isLastPhaseExist"
          >
            <v-btn
              slot="activator"
              color="primary"
              small
              :disabled="readonly || !canEdit || isLastPhaseExist"
              @click="
                user.hasEmployee
                  ? false
                  : showInfo('Пользователь не привязан к сотруднику')
              "
            >
              Добавить
            </v-btn>
            <v-list>
              <v-list-tile
                v-for="item in phaseTypes"
                :key="item.value"
                @click="activatePhasesPoint(item.value)"
              >
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </template>
      <v-spacer />
      <v-flex xs3>
        <app-reference
          v-model="country"
          label="Направление*"
          :rules="[v => !!v || '']"
          :without-clearable="true"
          resource="countries"
          component-name="Country"
          :outline="true"
          :height-field="40"
          :disabled="!canEdit"
          @input="changeDirection"
        />
      </v-flex>
      <v-btn
        small
        icon
        :disabled="phasesLoading"
        class="mr-0"
        @click="changeCompactMode"
      >
        <v-icon>{{ compactMode ? "fullscreen_exit" : "fullscreen" }}</v-icon>
      </v-btn>
      <v-dialog
        v-if="phasesEditorDialog"
        v-model="phasesEditorDialog"
        width="1200"
        persistent
      >
        <v-card>
          <PickUpEditor
            v-if="activePhase.value === 1"
            v-model="editingPhase"
            :user="user"
            :is-last-phase="checkIsLastPhase(editingPhase)"
            :disabled="!(canEdit && canEditPhase)"
            :is-disabled-add-comment="!isUserRoleCanEditPhase"
            @cancel="closeDialog"
            @readComments="markAsReadCommentsInPhase"
            @add-comment="updateComment"
          />
          <CombinationEditor
            v-if="activePhase.value === 3"
            v-model="editingPhase"
            :user="user"
            :is-last-phase="checkIsLastPhase(editingPhase)"
            :disabled="!(canEdit && canEditPhase)"
            :is-disabled-add-comment="!isUserRoleCanEditPhase"
            @cancel="closeDialog"
            @readComments="markAsReadCommentsInPhase"
            @add-comments="updateComment"
          />
          <NonStandartEditor
            v-if="activePhase.value === 2"
            v-model="editingPhase"
            :user="user"
            :is-last-phase="checkIsLastPhase(editingPhase)"
            :disabled="!(canEdit && isUserRoleCanEditPhase)"
            @cancel="closeDialog"
          />
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-data-table
          class="elevation-0"
          :loading="phasesLoading"
          :headers="headers"
          :items="filteredPhases"
          :disabled="phasesLoading"
          hide-actions
          no-data-text="Нет данных"
        >
          <template
            slot="headers"
            slot-scope="props"
          >
            <tr class="text-xs-left px-3">
              <th
                v-for="(header, index) in props.headers"
                :key="index"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template
            slot="items"
            slot-scope="props"
          >
            <tr
              class="clickable-row"
              :class="props.item.hasRerouting ? 'blue lighten-4' : ''"
              @dblclick="openDialog(props.item)"
            >
              <td>
                <TableCell
                  v-if="props.item.hasUnreadNotes"
                  icon="mail"
                  tooltip="Непрочитанные сообщения"
                  color="green"
                />
              </td>
              <td>
                <v-tooltip top>
                  <template slot="activator">
                    <v-icon
                      v-if="props.item.isCrossingUkrainianBorder"
                      color="primary"
                      dark
                    >
                      flag
                    </v-icon>
                  </template>
                  <span>Пересечение границы Украины</span>
                </v-tooltip>
              </td>
              <td>
                {{ items.indexOf(props.item) + 1 }}
              </td>
              <td>
                {{
                  props.item.state.id === 1
                    ? "В ожидании"
                    : props.item.state.id === 2
                      ? "В маршруте"
                      : props.item.state.id === 3
                        ? "В процессе"
                        : "Выполнено"
                }}
              </td>
              <td>
                {{
                  props.item.type.id === 1
                    ? "Заезд"
                    : props.item.type.id === 2
                      ? "Нестандарт"
                      : "Свозка"
                }}
              </td>
              <td>
                {{
                  props.item.sendingPoint.factory
                    ? props.item.sendingPoint.factory.title
                    : props.item.sendingPoint.warehouse
                      ? props.item.sendingPoint.warehouse.title
                      : ""
                }}
              </td>
              <td>{{ props.item.sendingPoint.address.title }}</td>
              <td>{{ props.item.unloadingDate | date }}</td>
              <td>
                {{
                  props.item.arrivalPoint.factory
                    ? props.item.arrivalPoint.factory.title
                    : props.item.arrivalPoint.warehouse
                      ? props.item.arrivalPoint.warehouse.title
                      : ""
                }}
              </td>
              <td>{{ props.item.arrivalPoint.address.title }}</td>
              <td>{{ props.item.route ? props.item.route.title : "" }}</td>
              <td>{{ props.item.vehicle ? props.item.vehicle.title : "" }}</td>
              <td>{{ props.item.counterparty ? props.item.counterparty.title : "" }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-layout>
</template>
<script>
import PickUpEditor from "./PickUpEditor.vue";
import CombinationEditor from "./CombinationEditor.vue";
import NonStandartEditor from "./NonStandartEditor.vue";
import TableCell from "../../../../components/TableCell.vue";
import mixin from "../../../../mixins/confirm-cancel-changes.js";
import { phaseStates } from "./shipping-phase-states.js";
import { changeShippingDirection } from "../../../../backend/shippingsApi.js";
import { getPhaseId } from "../../../../backend/phasesApi.js";
import { ePhaseTypes } from "./shipping-phase-types.js";
import { userRoles } from "../../../../enums/user-roles.js";

export default {
  components: {
    PickUpEditor,
    CombinationEditor,
    NonStandartEditor,
    TableCell,
  },
  mixins: [mixin],
  props: ["canEdit", "user", "disabled"],
  data() {
    return {
      phasesLoading: false,
      phasesPoint: false,
      activePhase: null,
      phasesEditorDialog: false,
      editingPhase: null,
      country: null,
    };
  },
  computed: {
    items() {
      return this.$store.getters["shipping/phases"];
    },
    filteredPhases() {
      if (this.items.length < 3) {
        return this.items;
      }
      if (!this.compactMode) {
        const current = this.items.find(
          i => i.state.id === phaseStates.INPROCESS,
        )
          ? this.items.find(i => i.state.id === phaseStates.INPROCESS)
          : this.items.find(i => i.state.id === phaseStates.AWAITING);
        const prev = this.items.find(
          (i, index) => index === this.items.indexOf(current) - 1,
        );
        const next = this.items.find(
          (i, index) => index === this.items.indexOf(current) + 1,
        );
        if (prev && current && next) {
          return [prev, current, next];
        } else if (!prev && current && next) {
          return this.items.slice(0, 3);
        } else {
          return this.items.slice(-3);
        }
      } else {
        return this.items;
      }
    },
    isPhaseActive: {
      get() {
        return this.$store.getters["shipping/isPhaseActive"];
      },
      set(value) {
        return this.$store.commit("shipping/setIsPhaseActive", value);
      },
    },
    isReleaseOrderActive: {
      get() {
        return this.$store.getters["shipping/isReleaseOrderActive"];
      },
      set(value) {
        return this.$store.commit("shipping/setIsReleaseOrderActive", value);
      },
    },
    readonly() {
      return this.$store.getters["shipping/splitted"];
    },
    compactMode: {
      get() {
        return this.$store.getters["shipping/compactMode"];
      },
      set(value) {
        return this.$store.commit("shipping/setCompactMode", value);
      },
    },
    id() {
      return this.$store.getters["shipping/id"];
    },
    headers() {
      return this.$store.getters["shipping/phasesHeaders"];
    },
    phaseTypes() {
      return [
        { value: ePhaseTypes.PICKUP, title: "Заезд" },
        { value: ePhaseTypes.NONSTANDART, title: "Нестандарт" },
        { value: ePhaseTypes.COMBINATION, title: "Свозка" },
      ];
    },
    isLastPhaseExist() {
      return this.items.some(i => {
        return i.isLast;
      });
    },
    direction() {
      return this.$store.getters["shipping/direction"];
    },
    isAdmin() {
      return !!this.user.roles.find(r => r.id === userRoles.Admin);
    },
    isUserRoleCanEditPhase() {
      return !!this.user.roles.find(
        r => r.id === userRoles.ClientManager || this.isAdmin,
      );
    },
    canEditPhase() {
      if (!this.editingPhase || this.isAdmin) {
        return true;
      }

      if (
        this.isUserRoleCanEditPhase &&
        !this.editingPhase.route &&
        this.editingPhase.state.id === phaseStates.AWAITING
      ) {
        return true;
      }
      return false;
    },
    isUserIsManager() {
      const manager = this.$store.getters["shipping/manager"];
      return this.user.employeeId === manager.id;
    },
  },
  watch: {
    direction: {
      handler(value) {
        if (value && value.id) {
          this.country = { ...value };
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getPhase(phaseId) {
      this.phasesLoading = true;
      this.editingPhase = await getPhaseId(this.id, phaseId);
      this.items.forEach(i => {
        if (this.items.length === 1) {
          this.editingPhase.changeState = true;
        } else if (
          this.items.length > 1 &&
          i.state.id === phaseStates.AWAITING
        ) {
          this.editingPhase.changeState = true;
        } else {
          this.editingPhase.changeState = false;
        }
      });
      this.$store.commit(
        "shipping/setDisabledState",
        this.items.find(i => i.id === this.editingPhase.id).disabledState,
      );
      if (this.isUserIsManager) {
        this.editingPhase.comments.forEach(c => {
          if (c.author?.id === this.user.id || this.isAdmin) {
            c.disabled = false;
            c.isReaded = true;
          } else {
            c.disabled = true;
          }
        });
      } else {
        this.editingPhase.comments.forEach(c => {
          if (c.author?.id === this.user.id || this.isAdmin) {
            c.disabled = false;
          } else {
            c.disabled = true;
          }
          c.isReaded = true;
        });
      }
      this.phasesLoading = false;
    },
    changePhaseActive() {
      this.$store.commit("shipping/setIsPhaseActive", true);
      this.$store.commit("shipping/setIsReleaseOrderActive", false);
    },
    changeReleaseOrderActive() {
      this.$store.commit("shipping/setIsPhaseActive", false);
      this.$store.commit("shipping/setIsReleaseOrderActive", true);
    },
    activatePhasesPoint(value) {
      if (value === 1) {
        this.activePhase = { value: 1, title: "Заезд" };
      } else if (value === 2) {
        this.activePhase = { value: 2, title: "Нестандарт" };
      } else if (value === 3) {
        this.activePhase = { value: 3, title: "Свозка" };
      } else {
        this.activePhase = null;
      }
      this.phasesEditorDialog = true;
    },
    changeCompactMode() {
      this.$store.commit("shipping/setCompactMode", !this.compactMode);
    },
    async openDialog(value) {
      this.activePhase = {
        value: value.type.id,
        title:
          value.type.id === 1
            ? "Заезд"
            : value.type.id === 2
              ? "Нестандарт"
              : "Свозка",
      };
      await this.getPhase(value.id);
      this.markAsReadCommentsInPhase();
      this.phasesEditorDialog = true;
    },
    closeDialog() {
      this.editingPhase = null;
      this.phasesEditorDialog = false;
    },
    async changeDirection() {
      if (!this.country) {
        return;
      }
      const direction = await changeShippingDirection(this.id, this.country);
      this.$store.commit("shipping/setDirection", direction);
      this.showInfo("Направление изменено");
    },
    checkIsLastPhase(phase) {
      if (!phase) return false;
      return (
        this.items.length ===
        this.items.findIndex(item => item.id == phase.id) + 1
      );
    },
    markAsReadCommentsInPhase() {
      this.items.forEach(i => {
        if (i.id === this.editingPhase.id) {
          i.hasUnreadNotes = false;
        }
      });
    },
    updateComment(comments) {
      this.editingPhase.comments = comments;
    },
  },
};
</script>
